<template>
	<div class="edit-modal">
		<div class="edit-modal-content">
			<form @submit.prevent="$emit('save', items)">
				<div class="title">
					<span>
						Configuración SEO
					</span>
					<button
						class="btn close-icon"
						type="button"
						@click="closeModal"
					>
						<img
							src="/static/img/icon-close.svg"
							alt="cerrar modal"
							height="24px"
							width="24px"
							@click="closeModal"
						>
					</button>
				</div>
				<div class="section text-center">
					<div class="title">
						<div class="tabs-container">
							<button
								class="tab"
								:class="{ 'active' : tab === 'title' }"
								type="button"
								@click="changeTab('title')"
							>
								<span>
									Título
								</span>
							</button>
							<button
								class="tab"
								:class="{ 'active' : tab === 'tags' }"
								type="button"
								@click="changeTab('tags')"
							>
								<span>
									Tags
								</span>
							</button>
							<button v-if="false"
								class="tab"
								:class="{ 'active' : tab === 'canonical' }"
								type="button"
								@click="changeTab('canonical')"
							>
								<span>
									Url Canónica
								</span>
							</button>
							<button
								class="tab"
								:class="{ 'active' : tab === 'open' }"
								type="button"
								@click="changeTab('open')"
							>
								<span>
									Open Graph
								</span>
							</button>					
							<button
								v-if="false"
								class="tab"
								:class="{ 'active' : tab === 'robot' }"
								type="button"
								@click="changeTab('robot')"
							>
								<span>
									Robots
								</span>
							</button>																
						</div>	
					</div>
					<div v-if="tab === 'title'" class="section">
						<div
							class="section-item">
							<label class="caption">
								Título
							</label>
							<input
								class="form-input"
								label="Título"
								placeholder="Título"
								type="text"
								v-model="itemsSeo.title" />
						</div>	
					</div>
					<div v-if="tab === 'tags'" class="section section-item-scroll">
						<div 
							v-for="(item, index) in itemsSeo.meta" 
							:key="index">
							<div class="section-item">
								<input
									class="form-input-name"
									label="Name"
									placeholder="Name"
									type="text"
									v-model="item.name" 
									/>
									&nbsp;
								<input
									class="form-input-content"
									label="Content"
									placeholder="Content"
									type="text"
									v-model="item.content" />									
									&nbsp;
								<button 
									v-if="index===0"
									class="btn-save"
									@click="addMeta"
									type="button"
									>Agregar</button>
								<button 
									v-if="index>0"
									class="btn-save"
									@click="delMeta(index)"
									type="button"
									>Borrar</button>							
							</div>
						</div>		
					</div>
					<div v-if="false" class="section">
						<div
							class="section-item">
							<label class="caption">
								Url
							</label>
							<input
								class="form-input"
								label="Url Canónica"
								placeholder="Url Canónica"
								type="text"
								v-model="itemsSeo.url" />
						</div>
					</div>
					<div v-if="tab === 'open'" class="section section-item-scroll">
						<div 
							v-for="(item, index) in itemsSeo.og" 
							:key="index">
							<div class="section-item">
								<input
									class="form-input-name"
									label="Property"
									placeholder="Property"
									type="text"
									v-model="item.property" 
									/>
									&nbsp;
								<input
									class="form-input-content"
									label="Content"
									placeholder="Content"
									type="text"
									v-model="item.content" />									
									&nbsp;
								<button 
									v-if="index===0"
									class="btn-save"
									@click="addOpen"
									type="button"
									>Agregar</button>
								<button 
									v-if="index>0"
									class="btn-save"
									@click="delOpen(index)"
									type="button"
									>Borrar</button>							
							</div>
						</div>	
					</div>
					<div v-if="tab === 'robot'" class="section">
						<div
							class="section-item">
							<label class="caption">
								Robots
							</label>
							<textarea
								class="form-input-textarea"
								label="Robots"
								placeholder="robots"
								type="text"
								v-model="itemsSeo.robot" />
						</div>
					</div>
					<br/>
					<button 
						class="btn-save"
						@click="saveSeo"
						type="button"
						>Guardar</button>
				</div>
			</form> 
		</div>
	</div>
</template>

<script>

	function data() {
		return {
			tab: 'title',
			itemsSeo: [],
			items: [],
			itemsNewMeta: {
				name: '',
				content: ''
			},
			itemsNewOpen: {
				property:'',
				content: ''
			}
		};
	}

	async function mounted()
	{
		console.log('mounted')
	}

	async function created(){
		console.log('created')
		try {
			
			const API_COMPANY = `company/${process.env.COMPANY_CODE}/app/${process.env.APP_CODE}`;
			console.log(API_COMPANY)
			const {data: response} = await this.$http.get(API_COMPANY);
			this.itemsSeo = response.data.helpers;
			if (this.itemsSeo.meta.length===0){
				this.itemsSeo.meta.push(this.itemsNewMeta)
			}
			if (this.itemsSeo.og.length===0){
				this.itemsSeo.og.push(this.itemsNewOpen)
			}
		} catch (err) {
			console.log('err', err)
			if (err.status === 500) {
				this.showError();
			}
		}
	}

	export default {
		name: 'edit-modal-seo',
		data,
		created,
		mounted,
		methods: {
			delOpen(index){
				this.itemsSeo.og.splice(index, 1);
			},
			addOpen() {
				this.itemsSeo.og.push({
				property:'',
				content: ''
			})
			},
			delMeta(index){
				this.itemsSeo.meta.splice(index, 1);
			},
			addMeta() {
				this.itemsSeo.meta.push({
				name: '',
				content: ''
			})
			},
			saveSeo(){
				const { company } = this.$store.state;
				company.helpers = this.itemsSeo;
				try {
					this.$http.put(`edit/companies/${process.env.APP_CODE}`, company);
					this.showNotification('Se actualizó correctamente');
					this.fetchCompany();
				} catch (error) {
					console.log('error', error)
					this.showError();
				}
				this.$emit('close-modal');
			},
			closeModal() {
				this.$emit('close-modal');
			},
			changeTab(type) {
				this.tab = type;
			},
		},
	};
</script>

<style lang="scss" scoped>


	.section-item-scroll {
		overflow-y: scroll;
		height: 360px;
		width: 100%;
		border: 1px solid #ddd;
		background: #f1f1f1;
	}

	.tabs-container {
		display: flex;
		width: 100%;
		height: 100%;
	}

	.tab {
		color: #fff;
		height: 49px;
		width: 70%;
		font-size: 18px;
		&.active {
			border-bottom: 3px solid #fff;
		}
	}

	.caption {
		font-size: 14px;
		padding: 15px;
	}
	
	.close-icon {
		height: 24px;
		margin: 0px;
		padding: 0px;
		width: 24px;
	}

	.form-input {
		border-radius: 4px;
		outline: 0;
		width: 100%;
	}

	.form-input-textarea {
		height: 180px;
	}

	.form-input-name {
		border-radius: 4px;
		outline: 0;
		width: 30%;
	}

	.form-input-content {
		border-radius: 4px;
		outline: 0;
		width: 70%;
	}

	.edit-modal {
		align-items: center;
		background-color: rgba(0, 0, 0, .8);
		display: flex;
		height: 100vh;
		justify-content: center;
		position: absolute;
		top: 0px;
		width: 100vw;
		z-index: 10;

		&-content {
			background-color: #fff;
			max-width: 900px;
			width: 90%;
			height: 600px;
			z-index: 11;
		}

		.section {
			padding: 36px 46px 24px;

			&-item {
				padding-bottom: 15px;
				text-align: left;
        @include display-flex;
			}
		}
	}

	.title {
		align-items: center;
		background-color: #001d32;
		color: #fff;
		display: flex;
		flex-wrap: wrap;
		font-size: 24px;
		justify-content: space-between;
		height: 59px;
		padding: 0px 37px;
		text-transform: uppercase;
	}


	.btn-save {
		background-color:#001d32;
		color: #fff;
		font-size: 14px;
		height: 45px;
		width: 132px;
		margin-bottom:0px;
		&.mt-32 {
			margin-top: 32px;
		}
	}

	.text-center {
		text-align: center;
	}
</style>



// WEBPACK FOOTER //
// src/components/commons/edit-modal-seo.vue